import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

const CustomerPrivateRoute = ({ children }) => {
	const location = useLocation();
	const isAuthenticated = !!localStorage.getItem('customerAccessToken');
	return isAuthenticated
		? children
		: <Navigate to="/customer-login" replace state={{ from: location.pathname + location.search }} />;
};

export default CustomerPrivateRoute;
